/* eslint-disable */
import React, { useState } from 'react';
import Modal from 'react-modal';

const DashboardViewsEditor = (props) => {
    let tableClass = 'my-dash-views-table-money'
    if (props.report === 'people' || props.page === 'people') {
        tableClass = 'my-dash-views-table-people'
    }
    if (props.report === 'customers' || props.page === 'customers') {
        tableClass = 'my-dash-views-table-customers'
    }

    if (props.editorPage) {
        return (
            <div>
                <h3>Edit Reports</h3>
                <p>Click Anywhere Outside of this Pop-up to Close</p>
                <table className={tableClass}>
                    <thead>
                        <tr>
                            <th>Name</th>
                            {!props.adminEditor ? <th>Who Can View</th> : null}
                            {!props.adminEditor ? <th>View Details</th> : null}
                            <th>NAICS</th>
                            {props.adminEditor ? <th>Parent Co / Firm</th> : null}
                            <th>Edit</th>
                            <th>Delete</th>
                        </tr>
                    </thead>
                    <tbody>
                        {props.dashboardViewModalState.user_views.map((v, i) => {
                            return (<tr key={`dashview-${i}`}>
                                <td style={{ 'textAlign': 'left' }}>{v.name}</td>
                                {!props.adminEditor ? <td>{v.private ? 'Only Me' : 'All Can View'}</td> : null}
                                {!props.adminEditor ? <td>{v.permission_details === 'edit_and_view' ? 'Edit & View' : 'View Only'}</td> : null}
                                <td>{v.naics && v.naics.length > 0 ? v.naics.join(', ') : 'All NAICS'}</td>
                                {props.adminEditor ? <td>{v.parent_ids && v.parent_ids.length > 0 ? v.parent_companies.map(c => c.name).join(', ') : 'All Parent Co / Firms'}</td> : null}
                                <td>
                                    <button className='dashboard-view-setting-btn' onClick={() => props.handleDashboardViewModal('edit_view', v)}><i className='fa fa-pencil dashboard-view-edit-icon'></i></button>
                                </td>
                                <td>
                                    <button className='dashboard-view-setting-btn' onClick={(e) => props.deleteDashBoardView(e, v.id)}><i className='fa fa-trash-o dashboard-view-edit-icon'></i></button>
                                </td>
                            </tr>)
                        })}
                    </tbody>
                </table>
                <button className='save-dashboard-btn' onClick={() => props.handleDashboardViewModal('add_view')}>+ Add New Report</button>
            </div>
        )
    } else {
        return (
            <div>
                <h3>Edit Your Dashboard Views</h3>
                <p>Click Anywhere Outside of this Pop-up to Close</p>
                <table className={tableClass}>
                    <thead>
                        <tr>
                            <th>Name</th>
                            <th>Who Can View</th>
                            <th>View Details</th>
                            <th>Edit</th>
                            <th>Delete</th>
                        </tr>
                    </thead>
                    <tbody>
                        {props.dashboardViewModalState.user_views.map((v, i) => {
                            return (<tr key={`dashview-${i}`}>
                                <td style={{ 'textAlign': 'left' }}>{v.name}</td>
                                <td>{v.private ? 'Only Me' : 'All Can View'}</td>
                                <td>{v.permission_details === 'edit_and_view' ? 'Edit & View' : 'View Only'}</td>
                                <td>
                                    <button className='dashboard-view-setting-btn' onClick={() => props.handleDashboardViewModal('edit_view', v)}><i className='fa fa-pencil dashboard-view-edit-icon'></i></button>
                                </td>
                                <td>
                                    <button className='dashboard-view-setting-btn' onClick={(e) => props.deleteDashBoardView(e, v.id)}><i className='fa fa-trash-o dashboard-view-edit-icon'></i></button>
                                </td>
                            </tr>)
                        })}
                    </tbody>
                </table>
                <button className='save-dashboard-btn' onClick={() => props.handleDashboardViewModal('add_view')}>+ Add New View</button>
            </div>
        )
    }
}

export default DashboardViewsEditor;